import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useParams } from "react-router-dom";
import { FETCH_TEAMS_FOR_OBJECTIVES } from "./graphql";
import ObjectiveForm from "./ObjectiveForm";
import ObjectiveView from "./ObjectiveView";

const TeamDetail = () => {
  const { teamId } = useParams();
  const { loading, error, data } = useQuery(FETCH_TEAMS_FOR_OBJECTIVES, {
    variables: { ids: [teamId] },
  });
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const team = data.teams[0];

  function addObjective() {
    modal.present({
      title: "Add Objective",
      center: true,
      children: <ObjectiveForm teamId={teamId} hide={modal.hide} />,
    });
  }

  return (
    <Page
      title={`${team.name} Objectives`}
      backTo="./.."
      rightButtons={<Button onClick={addObjective}>+ Add Objective</Button>}
    >
      <div className="p-6 grid grid-cols-1 xl:grid-cols-2 gap-6">
        {team.objectives.map((objective, index) => (
          <div key={index} className="card place-content-stretch">
            <ObjectiveView objective={objective} index={index} />
          </div>
        ))}
      </div>
    </Page>
  );
};

export default TeamDetail;
